<template>
  <div class="headbar-stack"
       :class="collapse?'position-collapse-left':'position-left'">
    <div class="headbar-row1">
    <div class="headbar-center">
      <!-- 左侧菜单切换按钮 -->
      <div class="left-section">
        <i class="el-icon-s-operation operation"
           @click="handleOpen"></i>
        <div id="myTissue" class="tissue-bar">
          <span class="tissue-name">{{ loginTissueName }}</span>
          <el-button type="primary"
                     size="small"
                     plain
                     class="tissue-switch-btn"
                     @click.stop="openTissueSelect">
            切换园区
          </el-button>
        </div>
      </div>

      <!-- 右侧功能区 -->
      <div class="right-section">
      <!-- 待办事项 -->
      <!-- <div class="nav-item tasks" @click="tasksClick()">
        <i class="el-icon-date"></i>
        <span class="nav-text">待办</span>
        <span class="badge" v-if="Number(tasksTotal) > 0">{{tasksTotal>99?'99+':tasksTotal}}</span>
      </div> -->

      <!-- 退出按钮 -->
      <div class="nav-item logout" @click="outClick()">
        <i class="el-icon-switch-button"></i>
        <span class="nav-text">退出</span>
      </div>

      <!-- 用户信息 - 使用原来的交互方式 -->
      <div class="nav-item user-info" @click="dropdownMenuClick">
        <div class="user-details">
          <span class="user-text">{{deptName}} {{employeeName}}</span>
        </div>
        <i class="el-icon-arrow-down arrow"></i>
      </div>
       </div>
    </div>
    </div>

    <div class="headbar-tabs-row">
      <MainTabStrip />
    </div>

    <!-- 原来的下拉菜单会通过 Vuex 控制显示 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/api/config'
import MainTabStrip from '@/components/MainTabStrip.vue'
export default {
  name: 'HeadBar',
  components: {
    MainTabStrip
  },
  computed: {
    ...mapState({
      collapse: state => state.app.collapse,
      headColor: state => state.app.headColor,
      dropdownMenuVisible: state => state.tabs.dropdownMenu
    })
  },
  props: {
    mailboxTotal: {
      type: Number,
      default: 0
    },
    tasksTotal: {
      type: Number,
      default: 0
    },
    language:{
      type:String,
      default:localStorage.languageName?localStorage.languageName:'中文'
    }
  },
  data () {
    return {
      pingImgUrl: config.pingImgUrl,
      mailboxDate:[],
      isCollapse: false,
      nickName: JSON.parse(localStorage.personal).nickName,
      userName: JSON.parse(localStorage.personal).userName,
      loginTissueName:localStorage.loginTissueName,
      Fullscreen: false,
      loginTissueId:localStorage.loginTissueId,
      date:'',
      day:'',
      week:'',
      surplus:'',
      isTips:false,
      openEndDate:'',
      avatar:JSON.parse(localStorage.personal).avatar?JSON.parse(localStorage.personal).avatar:'',
      companyName:JSON.parse(localStorage.personal).loginTissueName,
      deptName:JSON.parse(localStorage.personal).deptName?(JSON.parse(localStorage.personal).deptName + '：'):"",
      employeeName:JSON.parse(localStorage.personal).nickName?JSON.parse(localStorage.personal).nickName:JSON.parse(localStorage.personal).phonenumber,
    }
  },
  mounted () {
    if (window.location.href.indexOf('?') != -1) {
      let hrefRou = this.getUrlParams(window.location.href).mid?this.getUrlParams(window.location.href).mid.split('#')[0]:''
      if (hrefRou && !this.collapse) {
        this.$store.commit('onCollapse')
      }
    }
    // 添加这行
    document.addEventListener('click', this.handleGlobalClick)
    // 监听自动切换园区事件，手动同步当前园区显示（localStorage 非响应式）
    window.addEventListener('tissue-changed', this.onTissueChanged)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleGlobalClick)
    window.removeEventListener('tissue-changed', this.onTissueChanged)
  },
  methods: {
    positionDropdownMenu (anchorEl) {
      const menu = document.getElementById('dropdown-menu')
      if (!menu || !anchorEl || !anchorEl.getBoundingClientRect) return
      const rect = anchorEl.getBoundingClientRect()
      const gap = 8
      const right = Math.max(0, window.innerWidth - rect.right)
      menu.style.position = 'fixed'
      menu.style.top = `${rect.bottom + gap}px`
      menu.style.right = `${right}px`
      menu.style.left = 'auto'
    },
    // 修改下拉菜单点击方法
    dropdownMenuClick (event) {
      event.stopPropagation() // 阻止事件冒泡
      if (this.dropdownMenuVisible) {
        this.$store.commit('dropdownMenu', false)
        return
      }
      this.positionDropdownMenu(event.currentTarget || event.target)
      this.$store.commit('dropdownMenu', true)
    },
    
    // 添加全局点击处理方法
    handleGlobalClick() {
      this.$store.commit('dropdownMenu', false)
    },
    onTissueChanged () {
      this.loginTissueName = localStorage.loginTissueName
      this.loginTissueId = localStorage.loginTissueId

      // personal 里可能保存了 loginTissueName；保持两处一致（避免下次弹窗/展示用旧值）
      if (localStorage.personal) {
        try {
          const personal = JSON.parse(localStorage.personal)
          if (personal && personal.loginTissueName) this.companyName = personal.loginTissueName
        } catch (e) {}
      }
      if (!this.companyName) this.companyName = localStorage.loginTissueName

      // 切换园区后同样做一次到期提醒（右上角通知）
      this.notifyIfTissueExpiringSoonFromStorage()
    },

    parseDateTimeLoose (s) {
      if (s === undefined || s === null) return null
      const str = String(s).trim()
      if (!str) return null
      const d = new Date(str.replace(/-/g, '/'))
      if (Number.isNaN(d.getTime())) return null
      return d
    },
    formatDateOnly (s) {
      if (s === undefined || s === null) return ''
      const str = String(s).trim()
      if (!str) return ''
      const cut = str.split(' ')[0].split('T')[0]
      return cut.length >= 10 ? cut.slice(0, 10) : cut
    },

    notifyIfTissueExpiringSoonFromStorage () {
      const endStrRaw = localStorage.openEndDate !== undefined && localStorage.openEndDate !== null ? String(localStorage.openEndDate) : ''
      if (!endStrRaw) return
      const end = this.parseDateTimeLoose(endStrRaw)
      if (!end) return
      const endDateText = this.formatDateOnly(endStrRaw)
      const now = new Date()
      const diffMs = end.getTime() - now.getTime()
      const diffDays = Math.ceil(diffMs / (24 * 60 * 60 * 1000))
      const tissueName = localStorage.loginTissueName || this.loginTissueName || '当前园区'

      if (diffDays <= 30) {
        if (diffDays < 0) {
          this.$notify({
            title: '到期提醒',
            type: 'error',
            position: 'top-right',
            duration: 5000,
            message: `${tissueName} 已到期（到期时间：${endDateText}），请联系管理员续费`
          })
        } else {
          this.$notify({
            title: '到期提醒',
            type: 'warning',
            position: 'top-right',
            duration: 5000,
            message: `${tissueName} 将在 ${diffDays} 天后到期（到期时间：${endDateText}），请及时续费`
          })
        }
      }
    },
    
    mailboxClick(){
      this.$emit('mailboxClick', '1',this.mailboxTotal)
    },
    
    tasksClick(){
      this.$emit('tasksClick', '1',this.tasksTotal)
    },
    tissueClick(){
      this.$emit('tissueClick')
    },
    getEndTime(){
      let tineArry = (localStorage.openEndDate).split(' ')
      this.openEndDate = tineArry[0]
      let endTime = new Date(this.openEndDate).getTime()
      let nowTime = new Date().getTime()
      this.surplus = parseInt(((endTime - nowTime)/(3600*24*1000)))
      if(Number(this.surplus) < 31){
        this.isTips = true
      }
    },
    
    Timer() {
      var timerID = setInterval(this.updateTime, 1000);
      this.updateTime();
      return timerID;
    },
    
    handleOpen () {
      this.$store.commit('onCollapse')
    },
    
    updateTime() {
      var cd = new Date();
      this.date =
        this.zeroPadding(cd.getFullYear(), 4) +
        "-" +
        this.zeroPadding(cd.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(cd.getDate(), 2)
      this.day = cd.getDay()
      if(this.day == 0){
        this.week = '星期日'
      }else if(this.day == 1){
        this.week = '星期一'
      }else if(this.day == 2){
        this.week = '星期二'
      }else if(this.day == 3){
        this.week = '星期三'
      }else if(this.day == 4){
        this.week = '星期四'
      }else if(this.day == 5){
        this.week = '星期五'
      }else if(this.day == 6){
        this.week = '星期六'
      }
    },
    
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    
    // 全屏
    Big () {
      this.Fullscreen = true
      document.documentElement.requestFullscreen()
    },
    
    exitFullscreen () {
      this.Fullscreen = false
      document.exitFullscreen()
    },
    
    openTissueSelect () {
      this.$store.commit('dropdownTissue', true)
    },
    
    getUrlParams(url) {
      let obj = {};
      let urlStr = url.split('?')[1];
      if (urlStr) {
        let paramsArr = urlStr.split('&');
        for(let i = 0,len = paramsArr.length;i < len;i++){
            let arr = paramsArr[i].split('=');
            obj[arr[0]] = arr[1];
        }
      }
      return obj;
    },
    
    outClick(){
      this.$confirm('即将退出系统，是否继续？', '提示', {
        type: 'warning'
      }).then(() => {
        this.loding = true
        this.$store.commit('loding', true)
        this.$api.login.out({loginTissueId:localStorage.loginTissueId,username:JSON.parse(localStorage.personal).userName}).then(res => {
          this.loding = false
          this.$store.commit('loding', false)
          if (res.code === 0) {
            const rememberedTissueMap = localStorage.lastLoginTissueMap || ''
            const rememberedUsername = localStorage.username || ''
            localStorage.clear()
            if (rememberedTissueMap) {
              localStorage.lastLoginTissueMap = rememberedTissueMap
            }
            if (rememberedUsername) {
              localStorage.username = rememberedUsername
            }
            localStorage.password = ''
            localStorage.languageName = this.language
            this.$message({ message: res.msg, type: 'success' })
            localStorage.removeItem('token')
            localStorage.removeItem('roleId')
            localStorage.removeItem('userButtonList')
            this.$store.commit('RouterLoad', false)
            this.$router.push('/login')
            this.$store.commit('updateTabList', [])
            this.$store.commit('updateActiveTab', '')
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }, err => {
          console.log(err)
          localStorage.removeItem('token')
          localStorage.removeItem('roleId')
          this.$router.push('/login')
          this.loding = false
          this.$store.commit('loding', false)
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/style/mixins.styl'

// 顶栏：深色商务风，降低霓虹感
$hb-bg-top = #0b1330
$hb-bg-bottom = #070d22
$hb-accent = #60a5fa
$hb-text = rgba(255, 255, 255, 0.96)
$hb-text-secondary = rgba(186, 200, 228, 0.72)
$hb-hover = rgba(71, 85, 105, 0.26)
$hb-sheen = rgba(96, 165, 250, 0.1)

.headbar-stack
  position fixed
  top 0
  right 0
  z-index 1000
  display flex
  flex-direction column
  align-items stretch
  box-sizing border-box
  font-family 'Outfit', system-ui, -apple-system, 'Segoe UI', sans-serif
  -webkit-font-smoothing antialiased
  &::before
    content ''
    position absolute
    inset 0
    pointer-events none
    z-index 0
    background:
      radial-gradient(circle at 12% 0%, rgba(96, 165, 250, 0.08) 0%, transparent 30%),
      radial-gradient(circle at 88% 12%, rgba(59, 130, 246, 0.07) 0%, transparent 32%),
      repeating-linear-gradient(0deg, rgba(148, 163, 184, 0.012) 0px, rgba(148, 163, 184, 0.012) 1px, transparent 1px, transparent 6px)

.headbar-row1
  flex-shrink 0
  display flex
  align-items stretch
  flex-wrap nowrap
  height var(--headbar-height, 50px)
  min-height var(--headbar-height, 50px)
  box-sizing border-box
  background radial-gradient(ellipse 95% 130% at 12% -30%, $hb-sheen 0%, transparent 48%), linear-gradient(180deg, $hb-bg-top 0%, $hb-bg-bottom 100%)
  padding 0
  position relative
  z-index 1

.headbar-tabs-row
  flex-shrink 0
  display flex
  align-items center
  min-height var(--headbar-tabs-row-height, 44px)
  box-sizing border-box
  padding 0 12px 0 14px
  border-top 1px solid rgba(148, 163, 184, 0.18)
  background linear-gradient(180deg, #101a3d 0%, #0b1330 52%, #091027 100%)
  box-shadow inset 0 1px 0 rgba(148, 163, 184, 0.06)
  position relative
  z-index 1

.headbar-center
  flex 1
  min-width 0
  display flex
  align-items center
  justify-content space-between
  padding 0 1rem
  height 100%
  background radial-gradient(ellipse 75% 110% at 90% -25%, rgba(96, 165, 250, 0.1) 0%, transparent 44%), linear-gradient(180deg, $hb-bg-top 0%, $hb-bg-bottom 100%)

// 左侧区域
.left-section
  display flex
  align-items center
  min-width 0

.tissue-bar
  display flex
  align-items center
  padding 0 20px
  gap 10px
  font-size 16px
  color $hb-text

.tissue-name
  font-weight 600
  color $hb-text
  max-width 280px
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.tissue-switch-btn
  flex-shrink 0
  border-color: rgba(148, 163, 184, 0.36) !important
  color: #dbeafe !important
  background: rgba(30, 41, 59, 0.28) !important
  &:hover, &:focus
    border-color: rgba(147, 197, 253, 0.46) !important
    color: #fff !important
    background: rgba(51, 65, 85, 0.4) !important

.operation
  color $hb-text-secondary
  cursor pointer
  font-size 18px
  transition: all 0.3s ease
  padding 6px
  border-radius 6px
  
  &:hover
    color #fff
    background: $hb-hover
    transform: rotate(90deg)

// 右侧区域
.right-section
  display flex
  align-items center
  gap 12px

// 导航项通用样式
.nav-item
  display flex
  align-items center
  padding 6px 12px
  border-radius 8px
  cursor pointer
  transition: all 0.3s ease
  position relative
  color $hb-text
  
  &:hover
    background-color $hb-hover
    color #fff
    i
      color rgba(255, 255, 255, 0.9)
    .nav-text
      color #fff

  i
    font-size 14px
    margin-right 6px
    color $hb-text-secondary
    
  .nav-text
    font-size 15px
    font-weight 500
    color $hb-text

// 待办事项特殊样式
.tasks
  position relative
  
  .badge
    position absolute
    top 2px
    right 2px
    background-color #ff4d4f
    color #ffffff
    border-radius 10px
    min-width 18px
    height 18px
    line-height 18px
    text-align center
    font-size 10px
    font-weight bold
    box-shadow: 0 2px 6px rgba(255, 77, 79, 0.4)

// 退出按钮特殊样式
.logout
  &:hover
    background-color $hb-hover
    color #fff

// 用户信息样式
.user-info
  display flex
  align-items center
  padding 4px 12px
  border-radius 8px
  background: rgba(15, 23, 42, 0.5)
  border: 1px solid rgba(148, 163, 184, 0.2)
  position relative
  
  &:hover
    background: rgba(15, 23, 42, 0.72)
    border-color: rgba(147, 197, 253, 0.3)
  
  .user-details
    display flex
    align-items center
    line-height 1
    margin-right 8px
    
    .user-text
      font-size 15px
      font-weight 600
      color $hb-text
      
  .arrow
    font-size 12px
    color $hb-text-secondary
    transition: transform 0.3s ease

// 水平位置由 index.css 统一（卡片间距布局）
.headbar-stack.position-left,
.headbar-stack.position-collapse-left
  transition: left 0.3s ease, right 0.3s ease, top 0.3s ease

// 媒体查询 - 移动端适配
@media (max-width: 768px)
  .headbar-center
    padding 0 10px

  .right-section
    gap 8px
    
  .user-details
    .user-text
      font-size 12px
      color $hb-text
    
  .nav-text
    display none
    color $hb-text
    
  .nav-item
    padding 6px 10px
    
    i
      margin-right 0
      font-size 14px
      color $hb-text-secondary
</style>


// WEBPACK FOOTER //
// src/views/HeadBar/HeadBar.vue